<template>
    <div :class="['page-view', {loaded: !loading}]">
        <Breadcrumb/>
        <!-- <transition name="fade" mode="out-in"> -->
            <div class="page-view-gabarit" v-if="page">
                <component
                    :key="layout.id"
                    v-for="layout in page.layout"
                    :is="layout.acf_fc_layout"
                    :layout="layout"
                />
            </div>
        <!-- </transition> -->
        <MainFooter
            v-if="$route.name !== 'Contact' && $route.params.locale && page"
        />
    </div>
</template>

<script>
import PageView from '@/components/MixinPageView'
export default {
    name: 'page',
    mixins: [PageView],
    watch: {
        '$route.params.locale'() {
            this.requestData()
        }
    },
    activated()
    {
        if(!this.page) {
            this.requestData()
                .then(() => {
                    window.scroll(0, 0)
                    if(this.$route.name === 'Home') {
                        TweenMax.from(this.$el.querySelector('.page-view-gabarit .slide'), 4.0 , {scale: 1.1, clearProps: 'all'})
                    }
                })
        } else {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.loading = false
                    window.scroll(0, 0)
                }, 10)
            })
        }
    },
    deactivated()
    {
        this.loading = true
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.page-view-gabarit
    overflow-y: visible
</style>
